import CenteredContainer from '../../components/centeredContainer';
import SignIn from './signIn';

import './style.scss';
import {useDispatch, useSelector} from "react-redux";
import {
  clearForgotPasswordSuccess,
  clearLoginErrors,
  clearResetPasswordSuccess,
  loginUser
} from "../../actions/session";
import React, {useState} from "react";
import Alert from "../../components/common/alert";
import {MESSAGES, GENERAL_API_ERROR} from '../../constants';
import {Navigate} from "react-router-dom";
import {route as ACCEPT_TERMS_ROUTE} from "../acceptTerms";
import {getLockedOrExpiredErrorMessage} from "../../utils/session";

export const route = '/login';

const Login = (props) => {
  const dispatch = useDispatch();

  const resetPasswordSuccess = useSelector((state) => state.session.resetPasswordSuccess);
  const forgotPasswordSuccess = useSelector((state) => state.session.forgotPasswordSuccess);
  const loginApiError = useSelector((state) => state.session.loginApiError);
  const forgotPasswordApiErrors = useSelector((state) => state.session.forgotPasswordApiErrors);

  const alertResetPasswordSuccess = <Alert messageType='success' onDismiss={() => dispatch(clearResetPasswordSuccess())}>{MESSAGES.RESET_PASSWORD.resetPasswordSuccess}</Alert>

  const alertForgotPasswordSuccess = <Alert messageType='success' onDismiss={() => dispatch(clearForgotPasswordSuccess())}>{MESSAGES.FORGOT_PASSWORD.success}</Alert>
  const alertForgotPasswordApiError = <Alert messageType='error' onDismiss={() => dispatch(clearForgotPasswordSuccess())}>{(forgotPasswordApiErrors) ? getLockedOrExpiredErrorMessage(forgotPasswordApiErrors, MESSAGES.FORGOT_PASSWORD) : ''}</Alert>

  const [formSubmitted, setFormSubmitted] = useState(false);

  const mustAcceptTermsAndConditions = useSelector((state) => state.session.mustAcceptTermsUser);

  const submitAction = async (email, password) => {
    await dispatch(clearLoginErrors());
    await dispatch(loginUser(email, password));
    await setFormSubmitted(true);
  }

  const clearSigninErrors = async () => {
    await dispatch(clearLoginErrors());
    setFormSubmitted(false);
  }

  const alertLoginApiError = <Alert messageType='error' onDismiss={() => clearSigninErrors()}>{loginApiError in MESSAGES.LOGIN ? MESSAGES.LOGIN[loginApiError] : MESSAGES.LOGIN[GENERAL_API_ERROR]}</Alert>

  return (formSubmitted && mustAcceptTermsAndConditions) ? <Navigate to={ACCEPT_TERMS_ROUTE}/> : (
    <div className='main-content'>
      <div className='login-alerts'>
        {resetPasswordSuccess && alertResetPasswordSuccess}
        {forgotPasswordSuccess && alertForgotPasswordSuccess}
        {forgotPasswordApiErrors && alertForgotPasswordApiError}
        {loginApiError && alertLoginApiError}
      </div>
      <CenteredContainer>
        <div className='login-container'>
          <SignIn submitAction={submitAction}/>
          <span className='account-info-text'>If you would like an account, contact your school or district administrator.</span>
        </div>
      </CenteredContainer>
    </div>
  )
};

export default Login;
